import React from "react";
import { Box, Flex, Image } from "@chakra-ui/react";
import { HSeparator } from "components/separator/Separator";
import Logo from "../../../assets/img/logos/Logo.png";
import Logo_pequeño from "../../../assets/img/logos/Logo_pequeño.jpeg";
import { useMarca } from "context/MarcaContext";

export function SidebarBrand({ isCollapsed }) {
  // Los logos subidos en Configuraciones > Empresa; si no hay, los que trae la app.
  // Contraída usa el pequeño y, si no lo subieron, el principal.
  const { marca } = useMarca();
  const logoPropio = isCollapsed ? marca?.logoPequeno || marca?.logo : marca?.logo;

  return (
    <Flex align="center" direction="column" py="16px">
      <Box
        w={isCollapsed ? "56px" : "100%"}
        maxW={isCollapsed ? "56px" : "230px"}
        h={isCollapsed ? "56px" : "140px"}
        px={isCollapsed ? "4px" : "8px"}
        display="flex"
        alignItems="center"
        justifyContent="center"
        overflow="hidden"
        transition="all 0.3s ease"
        // En modo noche, una placa clara detrás: un logo oscuro no se ve sobre la barra
        // oscura, y recolorearlo dañaría los logos de varios colores.
        _dark={{ bg: "white", borderRadius: "14px", py: isCollapsed ? "4px" : "10px" }}
      >
        <Image
          src={logoPropio || (isCollapsed ? Logo_pequeño : Logo)}
          alt={marca?.nombre || "Logo"}
          maxW="100%"
          maxH="100%"
          w="auto"
          h="auto"
          objectFit="contain"
          objectPosition="center"
          borderRadius="8px"
          transition="all 0.3s ease"
        />
      </Box>
      {!isCollapsed && <HSeparator mb="20px" />}
    </Flex>
  );
}

export default SidebarBrand;
